import { put, call, takeLatest } from "redux-saga/effects";
import * as Actions from "us.collection.input-output/actions";
import * as API from "us.collection.input-output/services";
import { FileConverter } from "us.collection.input-output/constants/Actions";
import { $MessageBox } from "us.common/components";
const { fileConverter } = Actions;

const FileConverterSagas = {
  preview: function* (action: any): any {
    const params = action?.payload?.data ?? {};
    try {
      const data = yield call(API.fileConverter.file.preview, params);
      if (data.Result) {
        yield put(fileConverter.preview.success(data.Result));
      } else {
        $MessageBox(
          "error",
          `US.COLLECTION.INPUT-OUTPUT:FILE_CONVERTER.FAILED_TO_PREVIEW_FILE`,
          "",
          ""
        );
        yield put(fileConverter.preview.fail(new Error()));
      }
    } catch (error) {
      $MessageBox(
        "error",
        "US.COLLECTION.INPUT-OUTPUT:FILE_CONVERTER.FAILED_TO_PREVIEW_FILE",
        "",
        ""
      );
      yield put(fileConverter.preview.fail(new Error()));
    }
  },
  import: function* (action: any): any {
    const params = action?.payload?.data ?? {};
    try {
      const data = yield call(API.fileConverter.file.import, params);
      if (data.IsError) {
        $MessageBox(
            "error",
            "US.COLLECTION.INPUT-OUTPUT:FILE_CONVERTER.FILE_IMPORT_FAILED",
            "",
            ""
          );
          yield put(fileConverter.importFiles.fail(new Error()));
      } else {
        $MessageBox(
          "success",
          "US.COLLECTION.INPUT-OUTPUT:FILE_CONVERTER.FILE_IMPORT_SUCCESS",
          "",
          ""
        );
        yield put(fileConverter.importFiles.success(data.Result));
      }
    } catch (error) {
      $MessageBox(
        "error",
        "US.COLLECTION.INPUT-OUTPUT:FILE_CONVERTER.FILE_IMPORT_FAILED",
        "",
        ""
      );
      yield put(fileConverter.importFiles.fail(new Error()));
    }
  },
  getProfiles: function* (action: any): any {
    try {
      const data = yield call(API.fileConverter.profiles.get);
      if (Array.isArray(data)) {
        yield put(fileConverter.mappingProfiles.success(data));
      } else {
        yield put(fileConverter.mappingProfiles.fail({}));
      }
    } catch (error) {
      yield put(fileConverter.mappingProfiles.fail(error as any));
    }
  },
};

export default [
  takeLatest(FileConverter.IMPORT_FILE_START, FileConverterSagas.import),
  takeLatest(FileConverter.PREVIEW_FILE_START, FileConverterSagas.preview),
  takeLatest(
    FileConverter.GET_MAPPING_PROFILES_START,
    FileConverterSagas.getProfiles
  ),
];
